var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeplanModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / Folder_Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 13.333V8.33301M10 8.33301L7.5 9.99967M10 8.33301L12.5 9.99967M2.5 4.99967V13.9997C2.5 14.9331 2.5 15.3995 2.68166 15.756C2.84144 16.0696 3.09623 16.3251 3.40983 16.4849C3.766 16.6663 4.23249 16.6663 5.16409 16.6663H14.8359C15.7675 16.6663 16.2333 16.6663 16.5895 16.4849C16.9031 16.3251 17.1587 16.0698 17.3185 15.7562C17.5002 15.3996 17.5002 14.9329 17.5002 13.9995L17.5002 7.66616C17.5002 6.73274 17.5002 6.26602 17.3185 5.90951C17.1587 5.5959 16.9033 5.34112 16.5897 5.18133C16.2331 4.99967 15.7668 4.99967 14.8333 4.99967H10M2.5 4.99967H10M2.5 4.99967C2.5 4.0792 3.24619 3.33301 4.16667 3.33301H7.22876C7.63642 3.33301 7.84072 3.33301 8.03253 3.37906C8.20259 3.41989 8.36488 3.48739 8.514 3.57878C8.68214 3.68181 8.82651 3.82619 9.11458 4.11426L10 4.99967",
    stroke: "#282A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeplanModal);
export default __webpack_public_path__ + "static/media/upgradeplan_modal.c71914625afff462a1cac52923ed9b1a.svg";
export { ForwardRef as ReactComponent };